<template>
<div v-loading="loading">
<!-- TODO: 解开注释 -->
    <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
  <pt-production-task-detail 
    class="pt-production-task-detail__withData"
    @on-reload="load" 
    :bill="bill"
    :task="task" 
    :statuses="statuses" 
    :order="detail" 
    @handle-loading="val=>loading=val" 
  ></pt-production-task-detail>
</div>
  
</template>

<script>
import PtProductionTaskDetail from './index'
export default {
  name: 'pt-production-task-detail__withData',
  components: {
    'pt-production-task-detail': PtProductionTaskDetail
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      bill:null,
      detail: null,
      statuses: [],
      // 当前的异常任务
      task: null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
    }
  },
  watch: {
    id (val) {
      this.load()
    }
  },
  methods: {
    // 加载详情数据
    load () {
      // this.detail = {
      //     orderStatusEnum:'LAB_SAMPLES_RECEIVED',
      //     nextOrderAction:'DAI_GUI_HUAN'
      //   }
      //   this.statuses = [{
      //     action:'LAB_SAMPLES_RECEIVED'
      //   },{
      //     action:"ORDER_GET"
      //   }]
      this.loading = true
      this.$store.dispatch('getProductionTasksDetail', this.id).then((data) => {
        console.log('====d',data)
        this.loadFailed = false
        this.loading = false
        this.detail = data.productionTask
        this.bill = data.bill
        this.statuses = data.status
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        console.error(error)
        this.$message.error(error || '获取任务单信息失败！')
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
